// 起動シーン：素材ロード→ WorldScene へ
import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload(): void {
    // Kenneyタイルセット（16x16）
    this.load.spritesheet('town', 'tilesets/town.png', {
      frameWidth: 16,
      frameHeight: 16,
    });
    this.load.spritesheet('dungeon', 'tilesets/dungeon.png', {
      frameWidth: 16,
      frameHeight: 16,
    });

    // プレイヤー：歩行（96x128, 3列x4行, 各32x32）
    this.load.spritesheet('player_walk', 'sprites/player_walk.png', {
      frameWidth: 32,
      frameHeight: 32,
    });
    // プレイヤー：攻撃（128x32, 4列x1行, 各32x32）
    this.load.spritesheet('player_attack', 'sprites/player_attack.png', {
      frameWidth: 32,
      frameHeight: 32,
    });

    // 敵
    this.load.spritesheet('enemy_slime', 'sprites/enemy_slime.png', {
      frameWidth: 32,
      frameHeight: 32,
    });
    this.load.spritesheet('enemy_goblin', 'sprites/enemy_goblin.png', {
      frameWidth: 32,
      frameHeight: 32,
    });
    this.load.spritesheet('enemy_archer', 'sprites/enemy_archer.png', {
      frameWidth: 32,
      frameHeight: 32,
    });
    this.load.spritesheet('enemy_boss', 'sprites/enemy_boss.png', {
      frameWidth: 64,
      frameHeight: 64,
    });
  }

  create(): void {
    this.scene.start('WorldScene');
    this.scene.launch('UIScene');
  }
}
